import { useMutation } from "@tanstack/react-query";

import { changeGroupRequest } from "../requests/change-group-request";

export const useChangeGroupMutation = () => {
  return useMutation({
    mutationFn: changeGroupRequest,
  });
};
